/**
 * Revision History
 * 
 * 11/30/2021 ptkim       Add IFmsGlobal and its related
 */
import { IDictionary } from '../fms.core/data/TrackingModule';
import { Currency, User } from '../ifmsTypes';
import { MaintenanceSetup } from '../framework.core/setup/MaintenanceSetup';
import { SystemSetup } from '../framework.core/setup/SystemSetup';
import { ClientSetup } from '../framework.core/setup/ClientSetup';
import { FmsMaintenanceOption, FmsSystemOption, FmsClientOption, FmsMaintenanceComplianceOption } from '../fms.core/setup';
import { SecurityGrant } from '../framework.core/SecurityGrant';
import { FmsSecTask } from '../fms.core/constants';

let currencies:Array<Currency> = [];
let primaryCurrency:Currency|null = null;
let defaultPageSize = 50;
let users:Array<User> = [];

let dateFormat:string|undefined = undefined;
let dateTimeFormat:string|undefined = undefined;


export function getCurrencies() {
  return currencies;
}

export function setCurrencies(c:Array<Currency>) {
  if (c !== undefined && c !== null) {
    currencies = c;
  }
}

export function setPrimaryCurrency(c:Currency|null) {
  primaryCurrency = c;
}

export function getPrimaryCurrency() {
  return primaryCurrency;
}

export function setDefaultPageSize(p:number) {
  if (p) {
    defaultPageSize = p;
  }
}

export function getDefaultPageSize() {
  return defaultPageSize;
}

export function getUsers() {
  return users;
}

export function setUsers(u:Array<User>|null|undefined) {
  if (u !== undefined && u !== null ) {
    users = u;
  }
}

//<pt220911: Nonot use
// export function setBillingCodes(c:Array<BillingCodePreview>|null|undefined) {
//   if (c !== undefined && c !== null) {
//     billingCodes = c;
//   }
// }

// export function getBillingCodes() {
//   return billingCodes;
// }

// export function searchBillingCodes(queryString:string, context:string) {
//   if (!queryString) {
//     return [];
//   }

//   const b = getBillingCodes();

//   if (b && b.length > 0) {
//     const result = b.filter(x => x.codeLower === queryString.toLowerCase());

//     return context === 'OI'
//       ? result.filter(x => x.opType === 0)
//       : result;
//   }
// }
//pt220911>
export function setDateFormat(f:string|undefined) {
  dateFormat = f;

  fmsGlobal.DateBlank = dateFormat?.toLowerCase().replace('yyyy', '____').replace('mm', '__').replace('dd', '__');
}

export function getDateFormat() {
  return dateFormat;
}

export function setDateTimeFormat(f:string|undefined) {
  dateTimeFormat = f;
}

export function getDateTimeFormat() {
  return dateTimeFormat;
}

export function setFmsGlobalBySg(sg: SecurityGrant[], isSuntekAdmin: boolean) {
  fmsGlobal.CanFinalize = sg?.find(x => x.securityTaskCode === FmsSecTask.ToolRecog)?.grantAdd || isSuntekAdmin;
  fmsGlobal.CanFileLock = sg?.find(x => x.securityTaskCode === FmsSecTask.ToolOpClose)?.grantAdd || isSuntekAdmin;
  fmsGlobal.CanFileUnlock = sg?.find(x => x.securityTaskCode === FmsSecTask.ToolCancelOpClose)?.grantAdd || isSuntekAdmin;

  if (!isSuntekAdmin) {
    fmsGlobal.MnuCheckM = sg?.find(x => x.securityTaskCode === FmsSecTask.ToolBlock)?.grantAdd ?? false;

    //fmsGlobal.NoRelease = sg?.find(x => x.securityTaskCode === 'GROUP_BlockReleaseHBL')?.grantYesNo ?? false;
    fmsGlobal.NoProfitShow = sg?.find(x => x.securityTaskCode === 'GROUP_BlockOPProfitReport')?.grantYesNo ?? false;
    //fmsGlobal.NoBranchShow = sg?.find(x => x.securityTaskCode === 'GROUP_BlockBranch')?.grantYesNo ?? false;   //Applied using other options
    //fmsGlobal.NoShowAllData = sg?.find(x => x.securityTaskCode === 'GROUP_BlockShowingAllBranchData')?.grantYesNo ?? false;    // apply backend.
    fmsGlobal.NoBillingsShow =  sg?.find(x => x.securityTaskCode === 'GROUP_BlockOPBillingsTab')?.grantYesNo ?? false; 
    fmsGlobal.OPAcctBlockAfterClosed = sg?.find(x => x.securityTaskCode === 'GROUP_BlockAccountingAfterClose')?.grantYesNo ?? false;
    fmsGlobal.BlockAPApprove = sg?.find(x => x.securityTaskCode === 'GROUP_BlockAPApprove')?.grantYesNo ?? false;    //No field to be applied (based on 3.3 Bill List > Bill information - Hold check)
    fmsGlobal.BlockAPHold = sg?.find(x => x.securityTaskCode === 'GROUP_BlockAPHold')?.grantYesNo ?? false;    //No field to be applied (based on 3.3 Bill List > Bill information - Hold check)
  }

}


//<pt211130>
interface IFmsGlobal {
  SUNTEK_ID:string,
  SUNTEK_PW:string,
  SUPERUSER_ID:string,
  SUPERUSER_PW:string,
  NewAuth_SiS_EncSubsID:string,
  SuntekPhone:string,

  CanUseHybrid:boolean,
  IsDateDMY:boolean,
  CurrencyInfo:IDictionary<number>,

  PAPER_SIZE_LETTER_LANDSCAPE:number,
  PAPER_SIZE_LETTER: number,
  PAPER_SIZE_A4:number,
  PAPER_SIZE_A4_LANDSCAPE:number,

  AcmeID:string,
  AmsMode:string,
  AcmeID3:string,
  AcmeID4:string,
  FsType:string,

  UseNewLog:boolean,
  UseNewAcct:boolean,
  UseAgentCostGL:boolean,
  ChkAutoRate:boolean,
  BrokerGroup:string,

  UseNewAuth:boolean,		//<pt210604>

  // AcmeID dependent globals
  UseTruckBl:boolean,

  /**
   * LoginUser's SecurityGroupID
   */
  GroupID:string,

  readonly GLNO_DUTYAR:string,
  readonly GLNO_DUTYAP:string,
  readonly GLNO_DUTYAR_AGENT:string,
  readonly GLNO_DUTYAP_AGENT:string,
  readonly GLNO_DUTY_TO_CUST:string,
  readonly GLNO_DUTY_TO_AGENT:string,
  readonly GLNO_LOAN_TO_AGENT:string,
  readonly GLNO_COLLECT_FOR_AGENT:string,
  readonly GLNO_SECURITY_DEPOSIT:string,

  ARGLNo:string, // g_ArGlNo
  APGLNo:string, // g_ApGlNo
  AgentGLNo:string,
  AgentAPGLNo:string,
  PayGLNo:string, // g_PayGlno
  RcvGLNo:string, // g_RcvGLNo
  AdvPayGLNo:string, // g_AdvPay
  AdvRecGLNo:string, // g_AdvRec
  EarningGLNo:string,
  AGR1: number,
  AGR2: number,
  AGR3: number,
  HawbPSize:number,
  BlRemarks:string,
  FCountry:string,
  OohOfrtCode:string,
  OihFrtChg:string,
  OihChg: string,

  VatGLNo:string,
  VatRcvGLNo:string,
  VatRate:number,
  UseKorVat:boolean,

  CashInBankGLNo:string,
  SavingsGLNo:string,
  OtherSavingsGLNo:string,
  CheckReceivableGLNo:string,
  CheckPayableGLNo:string,

  BankLoan:string,
  SuspenseRcv:string,
  SuspensePay:string,
  LoanRcv:string,
  CreditCardRefund:string,
  LongTermLoan:string,
  AutoLoan:string,
  CashInBank:string,
  DividendPayable:string,
  SecurityDeposit:string,
  Capital:string,
  LoanInterIncome:string,
  LoanInterExpense:string,
  Investment:string,

  PrepaidExpense:string,
  DepreciationExpense:string,
  AmortizationExpense:string,
  BadDebtExpense:string,

  CreditCard:string,

  ShowChargesConfirmedAN:boolean,

  HowAmend:string,

  UseABIDB:boolean,

  /**
   * If v_blsumm.f_eta exists or not
   */
  ViewETA:boolean,

  LbsPerCbm:number,
  KgsPerCBM:number,
  AotherLocal:boolean,
  UseBranch:boolean,
  PimsID:string,
  PimsUserID:string,  // iFms Login email
  PimsUserPwd:string,	//<pt201109>
  PimsUserIDNo:string   //PimsDB [User].Id where email = PimsUserID
  PimsOwnerID:number,   //PimsDB [Customer].Id where isowner=1 && pimsid=pimsid
  SuspenseGl:string,

  IsCHBUser:boolean,
  IsFfmUser:boolean,
  IsXpenUser:boolean,
  IsCRMUser:boolean,

  LocalFontName:string,
  LocalFontCharset:string,
  MarkFontName:string,
  MarkFontCharset:string,

  UseNjour:boolean,
  UseCRDB:boolean,

  ReportNumber:number,
  ContainerTypes:string[],

  DateFormat:string,
  DateFormatYY:string,
  DateBlank:string,

  /**
   * MM/dd/yyyy hh:mm:ss
   */
  DateTimeFormat:string,

  /**
   * MM/dd/yyyy hh:mm (w/o seconds)
   */
  DateTimeMinFormat:string,

  /**
   * MM/dd/yyyy AM/PM hh:mm:ss
   */
  DateTimeAmPmFormat:string,

  /**
   * MM/dd/yyyy AM/PM hh:mm
   */
  DateTimeMinAmPmFormat:string,

  DateInterval:number,
  MnuCheckM:boolean,
  Center_No:string,

  FiscalEndMonth:number,
  FiscalStartMonth:number,

  IL3UserId:string,
  IL3UserPwd:string,

  IssuePlace:string,
  PsShareRatio:number,
  FsOptions:string,

  /**
   * SmartTrack public memo enable or not
   */
  EnableSTKMemo:boolean,

  ShareDocWIthABI:boolean,
  SharedABILicID:string,

  /**
   * frmMemo, modFunc.SubSetOIReminderMemo, frmMain.LoadMemoData
   */
  NewMemo:boolean,

  HeadType:string,
  ShowAmend: boolean,
  UseITNew: boolean,

  MSetup: MaintenanceSetup,
  FmsMOption: FmsMaintenanceOption,
  FmsMCplOption: FmsMaintenanceComplianceOption,
  SSetup: SystemSetup,
  FmsSOption: FmsSystemOption,
  CSetup: ClientSetup,
  FmsCOption: FmsClientOption,
  //<pt220831: Prohibited words used in invoice, bill no.>
  bannedWords:Array<string>,
  CloseDate:string|null,

  //<User Security
  NoRelease: boolean,
  //NoShowAllData: boolean,  // apply backend.
  BlockAPApprove: boolean,
  BlockAPHold: boolean,
  OPAcctBlockAfterClosed: boolean,
  //NoBranchShow: boolean,  // Applied using other options
  
  ShowAgentBalance: boolean,
  ShowCustomerBalance: boolean,
  ShowVendorBalance: boolean,
  
  CanFinalize: boolean,
  CanFileLock: boolean,
  CanFileUnlock: boolean,
  NoProfitShow: boolean,
  NoBillingsShow: boolean,
  //User Security>

  //<Setup Related
  CashierRelease: boolean,
  //>

  ChargeFscAE: string,
  ChargeSscAE: string,
  ChargeTsaAE: string,
  ChargeHandlingCAE: string,
}

let fmsGlobal:Partial<IFmsGlobal> = {
  SUNTEK_ID: "SiS",
  SUNTEK_PW: "",
  SUPERUSER_ID: "ssikor",
  SUPERUSER_PW: "",
  NewAuth_SiS_EncSubsID: "",
  SuntekPhone: '949-789-0070',

  CanUseHybrid: false,
  IsDateDMY: false,
  CurrencyInfo: { USD: 2, CAD:2, KRW: 0, JPY: 0, EUR: 2},

  PAPER_SIZE_LETTER_LANDSCAPE: 11,
  PAPER_SIZE_LETTER: 8.5,
  PAPER_SIZE_A4: 8.27,
  PAPER_SIZE_A4_LANDSCAPE: 11.69,

  GLNO_DUTYAR: "112600",
  GLNO_DUTYAP: "212600",
  GLNO_DUTYAR_AGENT: "112620",
  GLNO_DUTYAP_AGENT: "212620",
  GLNO_DUTY_TO_CUST: "212630",
  GLNO_DUTY_TO_AGENT: "112630",
  GLNO_LOAN_TO_AGENT: "112500",
  GLNO_COLLECT_FOR_AGENT: "212500",
  GLNO_SECURITY_DEPOSIT: "121100",	

  AdvRecGLNo: "212100",	
  AdvPayGLNo: "112100",	

  //Payment
  BankLoan: "211200",	
  SuspenseRcv: "212110",	
  SuspensePay: "112110",	
  LoanRcv: "112700",	
  CreditCardRefund: "431451",	
  LongTermLoan: "211210",	
  AutoLoan: "211220",	
  CashInBank: "111200",	
  DividendPayable: "211610",	
  SecurityDeposit: "121100",	
  Capital: "311100",	
  LoanInterIncome: "551110",	
  LoanInterExpense: "451110",	
  Investment: "121200",

  //Adjustment
  PrepaidExpense: "112200",	
  DepreciationExpense: "431520",	
  AmortizationExpense: "431510",	
  BadDebtExpense: "431530",	

  //Etc
  CreditCard: "211620",	
  bannedWords: ['N/A', 'N.A', 'NA', 'NOT ISSUED'],
  DateInterval: 99,
};

export function getFmsGlobal() {
  return fmsGlobal;
}